"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequisitionItemResponseToJSON = exports.RequisitionItemResponseFromJSONTyped = exports.RequisitionItemResponseFromJSON = exports.instanceOfRequisitionItemResponse = exports.RequisitionItemResponseTestPackageTypeEnum = exports.RequisitionItemResponseStatusEnum = exports.RequisitionItemResponseSpecialTypesEnum = exports.RequisitionItemResponseSourceEnum = exports.RequisitionItemResponseReqtypeEnum = exports.RequisitionItemResponseParentTypeEnum = exports.RequisitionItemResponseOrderTypeEnum = exports.RequisitionItemResponseOrderTagsEnum = exports.RequisitionItemResponsePaymentStatusEnum = exports.RequisitionItemResponseFormattedStageEnum = void 0;
var runtime_1 = require("../runtime");
var InsuranceBillingDto_1 = require("./InsuranceBillingDto");
var ReflexDetailsDto_1 = require("./ReflexDetailsDto");
var RequisitionAttachmentResponse_1 = require("./RequisitionAttachmentResponse");
var RequisitionConceptResponse_1 = require("./RequisitionConceptResponse");
var RequisitionItemFamilyHistoryStructuredResponse_1 = require("./RequisitionItemFamilyHistoryStructuredResponse");
var RequisitionItemHoldsResponse_1 = require("./RequisitionItemHoldsResponse");
var RequisitionItemIndicationStructuredResponse_1 = require("./RequisitionItemIndicationStructuredResponse");
var RequisitionItemResponseCarrierReasonForTesting_1 = require("./RequisitionItemResponseCarrierReasonForTesting");
var RequisitionItemResponsePathologyLab_1 = require("./RequisitionItemResponsePathologyLab");
var RequisitionItemResponsePathologyLabAdditionalInfo_1 = require("./RequisitionItemResponsePathologyLabAdditionalInfo");
var RequisitionItemResponsePractice_1 = require("./RequisitionItemResponsePractice");
var RequisitionItemResponseSendoutStatus_1 = require("./RequisitionItemResponseSendoutStatus");
var RequisitionItemResponseTumorProfilingReasonForTesting_1 = require("./RequisitionItemResponseTumorProfilingReasonForTesting");
var RequisitionOrderingClinicianResponse_1 = require("./RequisitionOrderingClinicianResponse");
var RequisitionOwnerResponse_1 = require("./RequisitionOwnerResponse");
var RequisitionPatientResponse_1 = require("./RequisitionPatientResponse");
var RequisitionPatientWithRelationshipsResponse_1 = require("./RequisitionPatientWithRelationshipsResponse");
var RequisitionPgxReasonForTestingResponse_1 = require("./RequisitionPgxReasonForTestingResponse");
/**
 * @export
 */
exports.RequisitionItemResponseFormattedStageEnum = {
    KitPurchased: 'KIT PURCHASED',
    KitShipped: 'KIT SHIPPED',
    OrderApproved: 'ORDER APPROVED',
    OrderSubmitted: 'ORDER SUBMITTED',
    SpecimenReceived: 'SPECIMEN RECEIVED',
    LabProcessing: 'LAB PROCESSING',
    PreCropHold: 'PRE-CROP HOLD',
    AnalysisAndInterpretation: 'ANALYSIS AND INTERPRETATION',
    PostCropHold: 'POST-CROP HOLD',
    ReportReleased: 'REPORT RELEASED',
    Cancelled: 'CANCELLED'
};
/**
 * @export
 */
exports.RequisitionItemResponsePaymentStatusEnum = {
    Complete: 'complete',
    Pending: 'pending',
    Empty: ''
};
/**
 * @export
 */
exports.RequisitionItemResponseOrderTagsEnum = {
    ConsentSigned: 'consent signed',
    ExomeSlice: 'exome_slice',
    FlipToCashElected: 'flip_to_cash_elected',
    FormsSubmitted: 'forms submitted',
    GeneticCounselingDismissed: 'genetic counseling dismissed',
    HasPreventativeBenefits: 'has_preventative_benefits',
    HbGovernmentPayor: 'hb_government_payor',
    HealthHistoryCompleted: 'health history completed',
    KitActivated: 'kit activated',
    KitPurchased: 'kit purchased',
    KitShipped: 'kit shipped',
    LowOopEstimateEmailSent: 'low oop estimate email sent',
    LowOopEstimateSmsSent: 'low oop estimate sms sent',
    MedicalNecessityMet: 'medical_necessity_met',
    MnrLetterOfMedicalNecessityDownloaded: 'mnr_letter_of_medical_necessity_downloaded',
    NoHbGovernmentPayor: 'no_hb_government_payor',
    OopEmailSent: 'oop email sent',
    OopNotApplicableEmailSent: 'oop not applicable email sent',
    OopNotApplicableSmsSent: 'oop not applicable sms sent',
    OopSmsSent: 'oop sms sent',
    OrderApproved: 'order approved',
    PatientDetailsCompleted: 'patient details completed',
    PatientPayEmailSent: 'patient pay email sent',
    PatientPaySmsSent: 'patient pay sms sent',
    PatientSummaryLetterDownloaded: 'patient_summary_letter_downloaded',
    PwnResultOnHold: 'pwn result on hold',
    TyrerCuzickOrdered: 'tyrer cuzick ordered'
};
/**
 * @export
 */
exports.RequisitionItemResponseOrderTypeEnum = {
    Carrier: 'carrier',
    CombiCc: 'combi_cc',
    CombiCdd: 'combi_cdd',
    CombiPd: 'combi_pd',
    CombiPfu: 'combi_pfu',
    CombiPoc: 'combi_poc',
    CombiRpl: 'combi_rpl',
    Diagnostic: 'diagnostic',
    Exome: 'exome',
    ExomePreventiveAddon: 'exome_preventive_addon',
    Nips: 'nips',
    Pgx: 'pgx',
    Preventive: 'preventive',
    SmaStat: 'sma-stat',
    SolidTumor: 'solid_tumor',
    Stat: 'stat',
    TumorProfiling: 'tumor_profiling',
    Wgs: 'wgs'
};
/**
 * @export
 */
exports.RequisitionItemResponseParentTypeEnum = {
    DemoteToDuoRemoveFather: 'demote_to_duo_remove_father',
    DemoteToDuoRemoveMother: 'demote_to_duo_remove_mother',
    DemoteToProbandOnly: 'demote_to_proband_only',
    PreventiveReport: 'preventive_report',
    Rereq: 'rereq',
    Rerun: 'rerun',
    Switch: 'switch',
    Upgrade: 'upgrade',
    Empty: ''
};
/**
 * @export
 */
exports.RequisitionItemResponseReqtypeEnum = {
    AnonymousBlood: 'Anonymous Blood',
    Clinical: 'Clinical',
    ClinicalCollaboration: 'Clinical Collaboration',
    Internal: 'Internal',
    PositiveControl: 'Positive Control',
    Research: 'Research'
};
/**
 * @export
 */
exports.RequisitionItemResponseSourceEnum = {
    Api: 'api',
    Backoffice: 'backoffice',
    Cgc: 'cgc',
    ClinicHub: 'clinic_hub',
    Emr: 'emr',
    Fht: 'fht',
    PatientInitiated: 'patient_initiated',
    PatientShare: 'patient_share',
    Portal: 'portal',
    PortalBouncer: 'portal-bouncer',
    Unspecified: 'unspecified'
};
/**
 * @export
 */
exports.RequisitionItemResponseSpecialTypesEnum = {
    FetalSample: 'fetal_sample',
    FvtExternal: 'fvt_external',
    FvtExternalWithPositiveControl: 'fvt_external_with_positive_control',
    FvtInternal: 'fvt_internal',
    FvtOnly: 'fvt_only',
    FvtWithAdditionalGenes: 'fvt_with_additional_genes',
    FvtWithFullGene: 'fvt_with_full_gene',
    HematologicMalignancy: 'hematologic_malignancy',
    Other: 'other',
    PositiveControl: 'positive_control',
    Reflex: 'reflex',
    TestOfRelatedSamples: 'test_of_related_samples',
    TestOfRelatedSamplesNeedsJointAnalysis: 'test_of_related_samples_needs_joint_analysis',
    Tp53VariantProgram: 'tp53_variant_program',
    VusRecommended: 'vus_recommended',
    VusResolution: 'vus_resolution'
};
/**
 * @export
 */
exports.RequisitionItemResponseStatusEnum = {
    OrderSubmitted: 'ORDER_SUBMITTED',
    SpecimenReceived: 'SPECIMEN_RECEIVED',
    LabProcessing: 'LAB_PROCESSING',
    PreCropHold: 'PRE_CROP_HOLD',
    AnalysisAndInterpretation: 'ANALYSIS_AND_INTERPRETATION',
    PostCropHold: 'POST_CROP_HOLD',
    ReportReleased: 'REPORT_RELEASED',
    Cancelled: 'CANCELLED'
};
/**
 * @export
 */
exports.RequisitionItemResponseTestPackageTypeEnum = {
    Carrier: 'carrier',
    CombiCc: 'combi_cc',
    CombiCdd: 'combi_cdd',
    CombiPd: 'combi_pd',
    CombiPfu: 'combi_pfu',
    CombiPoc: 'combi_poc',
    CombiRpl: 'combi_rpl',
    Diagnostic: 'diagnostic',
    Exome: 'exome',
    ExomePreventiveAddon: 'exome_preventive_addon',
    Nips: 'nips',
    Pgx: 'pgx',
    Preventive: 'preventive',
    SmaStat: 'sma-stat',
    SolidTumor: 'solid_tumor',
    Stat: 'stat',
    TumorProfiling: 'tumor_profiling',
    Wgs: 'wgs'
};
/**
 * Check if a given object implements the RequisitionItemResponse interface.
 */
function instanceOfRequisitionItemResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfRequisitionItemResponse = instanceOfRequisitionItemResponse;
function RequisitionItemResponseFromJSON(json) {
    return RequisitionItemResponseFromJSONTyped(json, false);
}
exports.RequisitionItemResponseFromJSON = RequisitionItemResponseFromJSON;
function RequisitionItemResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'accessionDate': !(0, runtime_1.exists)(json, 'accession_date') ? undefined : json['accession_date'],
        'addedGeneIds': !(0, runtime_1.exists)(json, 'added_gene_ids') ? undefined : json['added_gene_ids'],
        'attachments': !(0, runtime_1.exists)(json, 'attachments') ? undefined : (json['attachments'].map(RequisitionAttachmentResponse_1.RequisitionAttachmentResponseFromJSON)),
        'carrierReasonForTesting': !(0, runtime_1.exists)(json, 'carrier_reason_for_testing') ? undefined : (0, RequisitionItemResponseCarrierReasonForTesting_1.RequisitionItemResponseCarrierReasonForTestingFromJSON)(json['carrier_reason_for_testing']),
        'clinicalArea': !(0, runtime_1.exists)(json, 'clinical_area') ? undefined : json['clinical_area'],
        'clinicalFollowUp': !(0, runtime_1.exists)(json, 'clinical_follow_up') ? undefined : json['clinical_follow_up'],
        'collectionDate': !(0, runtime_1.exists)(json, 'collection_date') ? undefined : json['collection_date'],
        'concepts': !(0, runtime_1.exists)(json, 'concepts') ? undefined : (json['concepts'].map(RequisitionConceptResponse_1.RequisitionConceptResponseFromJSON)),
        'currentEstimatedReportDate': !(0, runtime_1.exists)(json, 'current_estimated_report_date') ? undefined : json['current_estimated_report_date'],
        'dateCreated': !(0, runtime_1.exists)(json, 'date_created') ? undefined : json['date_created'],
        'dateModified': !(0, runtime_1.exists)(json, 'date_modified') ? undefined : json['date_modified'],
        'datePromised': !(0, runtime_1.exists)(json, 'date_promised') ? undefined : json['date_promised'],
        'dressRehearsalRequisition': !(0, runtime_1.exists)(json, 'dress_rehearsal_requisition') ? undefined : json['dress_rehearsal_requisition'],
        'familyHistory': !(0, runtime_1.exists)(json, 'family_history') ? undefined : json['family_history'],
        'formattedStage': !(0, runtime_1.exists)(json, 'formatted_stage') ? undefined : json['formatted_stage'],
        'formattedProductionNotes': !(0, runtime_1.exists)(json, 'formatted_production_notes') ? undefined : json['formatted_production_notes'],
        'hasFmr1': !(0, runtime_1.exists)(json, 'has_fmr1') ? undefined : json['has_fmr1'],
        'hasSpecialFlag': !(0, runtime_1.exists)(json, 'has_special_flag') ? undefined : json['has_special_flag'],
        'holds': !(0, runtime_1.exists)(json, 'holds') ? undefined : (json['holds'].map(RequisitionItemHoldsResponse_1.RequisitionItemHoldsResponseFromJSON)),
        'hpos': !(0, runtime_1.exists)(json, 'hpos') ? undefined : json['hpos'],
        'icd10Codes': !(0, runtime_1.exists)(json, 'icd10_codes') ? undefined : json['icd10_codes'],
        'indication': !(0, runtime_1.exists)(json, 'indication') ? undefined : json['indication'],
        'individualAffected': !(0, runtime_1.exists)(json, 'individual_affected') ? undefined : json['individual_affected'],
        'billingEmail': !(0, runtime_1.exists)(json, 'billing_email') ? undefined : json['billing_email'],
        'billingPhone': !(0, runtime_1.exists)(json, 'billing_phone') ? undefined : json['billing_phone'],
        'insuranceBilling': !(0, runtime_1.exists)(json, 'insurance_billing') ? undefined : (json['insurance_billing'].map(InsuranceBillingDto_1.InsuranceBillingDtoFromJSON)),
        'paymentStatus': !(0, runtime_1.exists)(json, 'payment_status') ? undefined : json['payment_status'],
        'invitaeStudyCode': !(0, runtime_1.exists)(json, 'invitae_study_code') ? undefined : json['invitae_study_code'],
        'isCancelled': !(0, runtime_1.exists)(json, 'is_cancelled') ? undefined : json['is_cancelled'],
        'isExomeSliceOrder': !(0, runtime_1.exists)(json, 'is_exome_slice_order') ? undefined : json['is_exome_slice_order'],
        'isNySample': !(0, runtime_1.exists)(json, 'is_ny_sample') ? undefined : json['is_ny_sample'],
        'isTatExempt': !(0, runtime_1.exists)(json, 'is_tat_exempt') ? undefined : json['is_tat_exempt'],
        'mapperVersion': !(0, runtime_1.exists)(json, 'mapper_version') ? undefined : json['mapper_version'],
        'nipsReasonForTesting': !(0, runtime_1.exists)(json, 'nips_reason_for_testing') ? undefined : json['nips_reason_for_testing'],
        'nipsSpecialCodes': !(0, runtime_1.exists)(json, 'nips_special_codes') ? undefined : json['nips_special_codes'],
        'noChargeReason': !(0, runtime_1.exists)(json, 'no_charge_reason') ? undefined : json['no_charge_reason'],
        'ocrEligible': !(0, runtime_1.exists)(json, 'ocr_eligible') ? undefined : json['ocr_eligible'],
        'orderTags': !(0, runtime_1.exists)(json, 'order_tags') ? undefined : json['order_tags'],
        'orderType': !(0, runtime_1.exists)(json, 'order_type') ? undefined : json['order_type'],
        'orderingClinician': !(0, runtime_1.exists)(json, 'ordering_clinician') ? undefined : (0, RequisitionOrderingClinicianResponse_1.RequisitionOrderingClinicianResponseFromJSON)(json['ordering_clinician']),
        'owner': !(0, runtime_1.exists)(json, 'owner') ? undefined : (0, RequisitionOwnerResponse_1.RequisitionOwnerResponseFromJSON)(json['owner']),
        'parentReqid': !(0, runtime_1.exists)(json, 'parent_reqid') ? undefined : json['parent_reqid'],
        'parentType': !(0, runtime_1.exists)(json, 'parent_type') ? undefined : json['parent_type'],
        'patientSpecimens': !(0, runtime_1.exists)(json, 'patient_specimens') ? undefined : json['patient_specimens'],
        'patientUserPhone': !(0, runtime_1.exists)(json, 'patient_user_phone') ? undefined : json['patient_user_phone'],
        'patientUserEmail': !(0, runtime_1.exists)(json, 'patient_user_email') ? undefined : json['patient_user_email'],
        'patientUserRegistrationToken': !(0, runtime_1.exists)(json, 'patient_user_registration_token') ? undefined : json['patient_user_registration_token'],
        'patientUserHasLogin': !(0, runtime_1.exists)(json, 'patient_user_has_login') ? undefined : json['patient_user_has_login'],
        'patient': !(0, runtime_1.exists)(json, 'patient') ? undefined : (0, RequisitionPatientResponse_1.RequisitionPatientResponseFromJSON)(json['patient']),
        'patients': !(0, runtime_1.exists)(json, 'patients') ? undefined : (json['patients'].map(RequisitionPatientWithRelationshipsResponse_1.RequisitionPatientWithRelationshipsResponseFromJSON)),
        'paymentType': !(0, runtime_1.exists)(json, 'payment_type') ? undefined : json['payment_type'],
        'pgxReasonForTesting': !(0, runtime_1.exists)(json, 'pgx_reason_for_testing') ? undefined : (0, RequisitionPgxReasonForTestingResponse_1.RequisitionPgxReasonForTestingResponseFromJSON)(json['pgx_reason_for_testing']),
        'physicianSignDate': !(0, runtime_1.exists)(json, 'physician_sign_date') ? undefined : json['physician_sign_date'],
        'positiveFamilyHistory': !(0, runtime_1.exists)(json, 'positive_family_history') ? undefined : json['positive_family_history'],
        'positiveFinding': !(0, runtime_1.exists)(json, 'positive_finding') ? undefined : json['positive_finding'],
        'practiceId': !(0, runtime_1.exists)(json, 'practice_id') ? undefined : json['practice_id'],
        'practice': !(0, runtime_1.exists)(json, 'practice') ? undefined : (0, RequisitionItemResponsePractice_1.RequisitionItemResponsePracticeFromJSON)(json['practice']),
        'previousResults': !(0, runtime_1.exists)(json, 'previous_results') ? undefined : json['previous_results'],
        'primaryIndication': !(0, runtime_1.exists)(json, 'primary_indication') ? undefined : json['primary_indication'],
        'reflexDetails': !(0, runtime_1.exists)(json, 'reflex_details') ? undefined : (0, ReflexDetailsDto_1.ReflexDetailsDtoFromJSON)(json['reflex_details']),
        'reportDates': !(0, runtime_1.exists)(json, 'report_dates') ? undefined : json['report_dates'],
        'reqid': !(0, runtime_1.exists)(json, 'reqid') ? undefined : json['reqid'],
        'reqtype': !(0, runtime_1.exists)(json, 'reqtype') ? undefined : json['reqtype'],
        'reasonForTestingSummary': !(0, runtime_1.exists)(json, 'reason_for_testing_summary') ? undefined : json['reason_for_testing_summary'],
        'registrationToken': !(0, runtime_1.exists)(json, 'registration_token') ? undefined : json['registration_token'],
        'requisitionsSharingSpecimens': !(0, runtime_1.exists)(json, 'requisitions_sharing_specimens') ? undefined : json['requisitions_sharing_specimens'],
        'rereqSet': !(0, runtime_1.exists)(json, 'rereq_set') ? undefined : json['rereq_set'],
        'reviewedAt': !(0, runtime_1.exists)(json, 'reviewed_at') ? undefined : json['reviewed_at'],
        'salesforceLink': !(0, runtime_1.exists)(json, 'salesforce_link') ? undefined : json['salesforce_link'],
        'sendoutStatus': !(0, runtime_1.exists)(json, 'sendout_status') ? undefined : (0, RequisitionItemResponseSendoutStatus_1.RequisitionItemResponseSendoutStatusFromJSON)(json['sendout_status']),
        'source': !(0, runtime_1.exists)(json, 'source') ? undefined : json['source'],
        'specialTypes': !(0, runtime_1.exists)(json, 'special_types') ? undefined : json['special_types'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : json['status'],
        'tatExemptTags': !(0, runtime_1.exists)(json, 'tat_exempt_tags') ? undefined : json['tat_exempt_tags'],
        'testPackageRequisitions': !(0, runtime_1.exists)(json, 'test_package_requisitions') ? undefined : json['test_package_requisitions'],
        'testPackageType': !(0, runtime_1.exists)(json, 'test_package_type') ? undefined : json['test_package_type'],
        'tumorProfilingReasonForTesting': !(0, runtime_1.exists)(json, 'tumor_profiling_reason_for_testing') ? undefined : (0, RequisitionItemResponseTumorProfilingReasonForTesting_1.RequisitionItemResponseTumorProfilingReasonForTestingFromJSON)(json['tumor_profiling_reason_for_testing']),
        'indicationStructured': !(0, runtime_1.exists)(json, 'indication_structured') ? undefined : (0, RequisitionItemIndicationStructuredResponse_1.RequisitionItemIndicationStructuredResponseFromJSON)(json['indication_structured']),
        'familyHistoryStructured': !(0, runtime_1.exists)(json, 'family_history_structured') ? undefined : (0, RequisitionItemFamilyHistoryStructuredResponse_1.RequisitionItemFamilyHistoryStructuredResponseFromJSON)(json['family_history_structured']),
        'pathologyLab': !(0, runtime_1.exists)(json, 'pathology_lab') ? undefined : (0, RequisitionItemResponsePathologyLab_1.RequisitionItemResponsePathologyLabFromJSON)(json['pathology_lab']),
        'pathologyLabAdditionalInfo': !(0, runtime_1.exists)(json, 'pathology_lab_additional_info') ? undefined : (0, RequisitionItemResponsePathologyLabAdditionalInfo_1.RequisitionItemResponsePathologyLabAdditionalInfoFromJSON)(json['pathology_lab_additional_info']),
    };
}
exports.RequisitionItemResponseFromJSONTyped = RequisitionItemResponseFromJSONTyped;
function RequisitionItemResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'accession_date': value.accessionDate,
        'added_gene_ids': value.addedGeneIds,
        'attachments': value.attachments === undefined ? undefined : (value.attachments.map(RequisitionAttachmentResponse_1.RequisitionAttachmentResponseToJSON)),
        'carrier_reason_for_testing': (0, RequisitionItemResponseCarrierReasonForTesting_1.RequisitionItemResponseCarrierReasonForTestingToJSON)(value.carrierReasonForTesting),
        'clinical_area': value.clinicalArea,
        'clinical_follow_up': value.clinicalFollowUp,
        'collection_date': value.collectionDate,
        'concepts': value.concepts === undefined ? undefined : (value.concepts.map(RequisitionConceptResponse_1.RequisitionConceptResponseToJSON)),
        'current_estimated_report_date': value.currentEstimatedReportDate,
        'date_created': value.dateCreated,
        'date_modified': value.dateModified,
        'date_promised': value.datePromised,
        'dress_rehearsal_requisition': value.dressRehearsalRequisition,
        'family_history': value.familyHistory,
        'formatted_stage': value.formattedStage,
        'formatted_production_notes': value.formattedProductionNotes,
        'has_fmr1': value.hasFmr1,
        'has_special_flag': value.hasSpecialFlag,
        'holds': value.holds === undefined ? undefined : (value.holds.map(RequisitionItemHoldsResponse_1.RequisitionItemHoldsResponseToJSON)),
        'hpos': value.hpos,
        'icd10_codes': value.icd10Codes,
        'indication': value.indication,
        'individual_affected': value.individualAffected,
        'billing_email': value.billingEmail,
        'billing_phone': value.billingPhone,
        'insurance_billing': value.insuranceBilling === undefined ? undefined : (value.insuranceBilling.map(InsuranceBillingDto_1.InsuranceBillingDtoToJSON)),
        'payment_status': value.paymentStatus,
        'invitae_study_code': value.invitaeStudyCode,
        'is_cancelled': value.isCancelled,
        'is_exome_slice_order': value.isExomeSliceOrder,
        'is_ny_sample': value.isNySample,
        'is_tat_exempt': value.isTatExempt,
        'mapper_version': value.mapperVersion,
        'nips_reason_for_testing': value.nipsReasonForTesting,
        'nips_special_codes': value.nipsSpecialCodes,
        'no_charge_reason': value.noChargeReason,
        'ocr_eligible': value.ocrEligible,
        'order_tags': value.orderTags,
        'order_type': value.orderType,
        'ordering_clinician': (0, RequisitionOrderingClinicianResponse_1.RequisitionOrderingClinicianResponseToJSON)(value.orderingClinician),
        'owner': (0, RequisitionOwnerResponse_1.RequisitionOwnerResponseToJSON)(value.owner),
        'parent_reqid': value.parentReqid,
        'parent_type': value.parentType,
        'patient_specimens': value.patientSpecimens,
        'patient_user_phone': value.patientUserPhone,
        'patient_user_email': value.patientUserEmail,
        'patient_user_registration_token': value.patientUserRegistrationToken,
        'patient_user_has_login': value.patientUserHasLogin,
        'patient': (0, RequisitionPatientResponse_1.RequisitionPatientResponseToJSON)(value.patient),
        'patients': value.patients === undefined ? undefined : (value.patients.map(RequisitionPatientWithRelationshipsResponse_1.RequisitionPatientWithRelationshipsResponseToJSON)),
        'payment_type': value.paymentType,
        'pgx_reason_for_testing': (0, RequisitionPgxReasonForTestingResponse_1.RequisitionPgxReasonForTestingResponseToJSON)(value.pgxReasonForTesting),
        'physician_sign_date': value.physicianSignDate,
        'positive_family_history': value.positiveFamilyHistory,
        'positive_finding': value.positiveFinding,
        'practice_id': value.practiceId,
        'practice': (0, RequisitionItemResponsePractice_1.RequisitionItemResponsePracticeToJSON)(value.practice),
        'previous_results': value.previousResults,
        'primary_indication': value.primaryIndication,
        'reflex_details': (0, ReflexDetailsDto_1.ReflexDetailsDtoToJSON)(value.reflexDetails),
        'report_dates': value.reportDates,
        'reqid': value.reqid,
        'reqtype': value.reqtype,
        'reason_for_testing_summary': value.reasonForTestingSummary,
        'registration_token': value.registrationToken,
        'requisitions_sharing_specimens': value.requisitionsSharingSpecimens,
        'rereq_set': value.rereqSet,
        'reviewed_at': value.reviewedAt,
        'salesforce_link': value.salesforceLink,
        'sendout_status': (0, RequisitionItemResponseSendoutStatus_1.RequisitionItemResponseSendoutStatusToJSON)(value.sendoutStatus),
        'source': value.source,
        'special_types': value.specialTypes,
        'status': value.status,
        'tat_exempt_tags': value.tatExemptTags,
        'test_package_requisitions': value.testPackageRequisitions,
        'test_package_type': value.testPackageType,
        'tumor_profiling_reason_for_testing': (0, RequisitionItemResponseTumorProfilingReasonForTesting_1.RequisitionItemResponseTumorProfilingReasonForTestingToJSON)(value.tumorProfilingReasonForTesting),
        'indication_structured': (0, RequisitionItemIndicationStructuredResponse_1.RequisitionItemIndicationStructuredResponseToJSON)(value.indicationStructured),
        'family_history_structured': (0, RequisitionItemFamilyHistoryStructuredResponse_1.RequisitionItemFamilyHistoryStructuredResponseToJSON)(value.familyHistoryStructured),
        'pathology_lab': (0, RequisitionItemResponsePathologyLab_1.RequisitionItemResponsePathologyLabToJSON)(value.pathologyLab),
        'pathology_lab_additional_info': (0, RequisitionItemResponsePathologyLabAdditionalInfo_1.RequisitionItemResponsePathologyLabAdditionalInfoToJSON)(value.pathologyLabAdditionalInfo),
    };
}
exports.RequisitionItemResponseToJSON = RequisitionItemResponseToJSON;
